// Referral Types
export const NEW_REFERRAL_STATUS: number = 7;
export const REQUEST_FOR_REEVALUATION_STATUS: number = 4;

// NYC ID is 6, 7 or 9 digits long
export const NYC_ID_LENGTH_SIX: number = 6;
export const NYC_ID_LENGTH_SEVEN: number = 7;
export const NYC_ID_LENGTH_NINE: number = 9;

// eiId Length is 6 or 7 digits long
export const EI_ID_LENGTH_SIX: number = 6;
export const EI_ID_LENGTH_SEVEN: number = 7;

// eiDates
export const SEPTEMBER_FOURTH: string = 'September 4, ';
export const OCTOBER_FIRST: string = 'October 1, ';
export const MARCH_FOURTH: string = 'March 4, ';
export const APRIL_FIRST: string = 'April 1, ';

// Length of the first and last names
export const STUDENT_FIRST_AND_LAST_NAME_LENGTH: number = 1;

// Years
export const TWO_YEARS: number = 2;
export const THREE_YEARS: number = 3;

// Months; starting from 0 based index to 11. January is 0 ... December is 11.
export const MARCH: number = 2;
export const APRIL: number = 3;
export const JULY: number = 6;
export const AUGUST: number = 7;
export const SEPTEMBER: number = 8;
export const OCTOBER: number = 9;

// Days
export const DAY_ONE: number = 1;
export const DAY_FOUR: number = 4;

// Button Text
export const CREATE_LINK_STUDENT_TEXT: string = 'createLinkStudent';

//DBN Array length
export const DBN_ARRAY_LENGTH: number = 0;

//DBN First index
export const DBN_FIRST_INDEX: number = 0;

// Error Messages
export const CHILD_WILL_BE_ELIGIBLE_FOR_INITIAL_REFERRAL_STARTING_TEXT: string =
  'The child will be eligible for an Initial Referral starting ';

// ATS Status Codes:

// Active
export const ACTIVE: string = 'ACTIVE';
export const ACTIVE_STATUS_CODE: string = 'A';

// Discharged
export const DISCHARGED: string = 'DISCHARGED';
export const DISCHARGED_STATUS_CODE: string = 'D';

// Closed
export const CLOSED: string = 'Closed';
